import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {useDispatch, useSelector} from "react-redux";
import AssignmentSharpIcon from '@material-ui/icons/AssignmentSharp';
import ExternalThreatOverview from "./ExternalThreatOverview";
import TargetsSection from "./TargetsSection";
import {boardChangeActiveTab} from "../../../../../actions";
import VectorsSection from "./VectorsSection";
import BBIconNetworkGlobe from "../../../../../assets/bbCustomIcons/BBIconNetworkGlobe";
// import {BBTourBreachBoard} from "./BBTourBreachBoard";
import BBIconChecklistSecurityLock from "../../../../../assets/bbCustomIcons/BBIconChecklistSecurityLock";
import ControlsSection from "./ControlsSection";
import BBIconVector from "../../../../../assets/bbCustomIcons/BBIconVector";
import CustomerStatusModal from "../../../../../components/customBreachBits/modals/CustomerStatusModal";
import {bbIsBetasOk} from "../../../../../util/bbHelpers";
import {useHistory} from "react-router-dom";


function TabContainer({children, dir}) {
    return (
        <div dir={dir} style={{padding: 8 * 3}}>
            {children}
        </div>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
};

const ExternalThreatContent = (props) => {
    const {boardActiveTab} = useSelector(({misc}) => misc);
    const authUser = useSelector(({auth}) => auth.authUser);
    const dispatch = useDispatch();
    const highestTabIndex = bbIsBetasOk(authUser) ? 3 : 2;
    const {customerInView, customers} = useSelector(({customer}) => customer);
    // console.log("Customers in ExternalThreatContent: ", customers);
    // const customer = getInViewCustomerObject(customerInView, customers);
    const {match} = props;
    let urlPageTab = match.params.pageTab
        ? match.params.pageTab
        : null;
    let history = useHistory()

    // const tabTurn = (newValue) => dispatch(boardChangeActiveTab(newValue));

    const convertUrlPageTabToTabIndex = (urlValue) => {
        //0 overview
        //1 Attack Surface
        //2 Vectors
        //3 Controls

        switch (urlValue) {
            case 'Overview' :
                return 0
            case 'AttackSurface':
                return 1
            case 'Vectors':
                return 2
            // case 'Controls':
            //     if (bbIsBetasOk(authUser)) {
            //         return 3
            //     } else {
            //         return 0
            //     }
            default:
                return 0
        }
    }

    const convertTabIndexToUrlPage = (indexValue) => {
        //0 overview
        //1 Attack Surface
        //2 Vectors
        //3 Controls

        switch (indexValue) {
            case 0 :
                return 'Overview'
            case 1:
                return 'AttackSurface'
            case 2:
                return 'Vectors'
            // case 3:
            //     if (bbIsBetasOk(authUser)) {
            //         return 'Controls'
            //     } else {
            //         return 'Overview'
            //     }

            default:
                return 'Overview'
        }
    }

    const changeActiveTab = (newValue) => {

        if (newValue > -1 && newValue <= highestTabIndex) {
            dispatch(boardChangeActiveTab(newValue));
        } else {
            dispatch(boardChangeActiveTab(0));
        }
        history.push(`/board/CIRT/external/${convertTabIndexToUrlPage(newValue)}`)
    }

    useEffect(() => {
        //enables full back button and history behavior
        dispatch(boardChangeActiveTab(convertUrlPageTabToTabIndex(urlPageTab)));
    }, [match]);

    const {theme} = props;

        return (
            <div className="w-100 animated fadeIn animation-duration-7" >
                {!!customerInView && <CustomerStatusModal/>}

                {/*<BBTourBreachBoard tabTurn={changeActiveTab}/>*/}
                <AppBar position="sticky" color="default">
                    <Tabs
                        value={boardActiveTab}
                        onChange={(event, newValue) => changeActiveTab(newValue)}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        scrollButtons="on"
                    >
                        <Tab icon={<AssignmentSharpIcon/>} className="tab tourStepOverviewTab" label="Overview"/>
                        <Tab icon={<BBIconNetworkGlobe/>} className="tab tourStepAttackSurfaceTab" label="Attack Surface"/>
                        <Tab icon={<BBIconVector/>} className="tab tourStepVectorsTab" label="Vectors"/>
                        {/*{bbIsBetasOk(authUser) &&*/}
                        {/*    <Tab icon={<BBIconChecklistSecurityLock/>} className="tab tourStepControlsTab"*/}
                        {/*     label="Controls"/>*/}
                        {/*}*/}
                    </Tabs>
                </AppBar>
                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={boardActiveTab}
                    onChangeIndex={(event, newValue) => changeActiveTab(newValue)}
                    style={(!!customerInView && customers.hasOwnProperty(customerInView) && customers[customerInView].StatusId !== 4) ? {filter: "blur(6px)"} : null}
                >
                    <TabContainer dir={theme.direction}>
                        <ExternalThreatOverview customerId={customerInView} onChangeActiveTab={changeActiveTab}/>
                    </TabContainer>
                    <TabContainer dir={theme.direction}>
                        <TargetsSection customerId={customerInView}/>
                    </TabContainer>
                    <TabContainer dir={theme.direction}>
                        <VectorsSection
                            customerId={customerInView}
                        />
                    </TabContainer>
                    {/*<TabContainer dir={theme.direction}>*/}
                    {/*    {bbIsBetasOk(authUser) &&*/}
                    {/*        <ControlsSection customerId={customerInView}/>*/}
                    {/*    }*/}
                    {/*</TabContainer>*/}
                </SwipeableViews>
            </div>
        );

}

ExternalThreatContent.propTypes = {
    theme: PropTypes.object.isRequired,
};

export default withStyles(null, {withTheme: true})(ExternalThreatContent);